const { formatText } = require('core/i18n').i18n;

const ITEMS = [
  {
    icon: 'icon-transparencia',
    text: () => formatText('aggregatorResume-itemSecureInfoDescription'),
    title: () => formatText('aggregatorResume-itemSecureInfoTitle'),
  },
  {
    icon: 'icon-estrategia',
    text: () => formatText('aggregatorResume-itemMakesEstimationsDescription'),
    title: () => formatText('aggregatorResume-itemMakesEstimationsTitle'),
  },
  {
    icon: 'icon-ahorra-dinero',
    text: () => formatText('aggregatorResume-itemControlExpensasDescription'),
    title: () => formatText('aggregatorResume-itemControlExpensasTitle'),
  },
  {
    icon: 'icon-simplificar',
    text: () => formatText('aggregatorResume-itemCheckMovementsDescription'),
    title: () => formatText('aggregatorResume-itemCheckMovementsTitle'),
  },
];

module.exports = { ITEMS };
